
import { i18nText } from '@/locales';

import { Component, Prop, Vue } from 'vue-property-decorator';
import FormGroup from '@/UI/components/common/form/FormGroup.vue';
import PageTitle from "@/UI/components/common/PageTitle.vue";

import moment from 'moment';
import {message} from "ant-design-vue";

import {ServiceStore} from "@/store/modules/Services";
import {IServices, IServicesListItem} from "@/entity/services/services.types";

import VisitCreateForm from "@/form/visits/visitCreate";
import VisitGeneralForm from "@/form/visits/visitGeneral";

import { StoresStore } from '@/store/modules/Warehouse/Warehouse';
import { ProductsStore } from "@/store/modules/Warehouse/Products";
import { ConsumableStore } from "@/store/modules/Consumables";

import { IProducts, IProductsItem, Products } from "@/entity/warehouse/Products/Products.types";
import { IWarehouse, IWarehouseItem } from '@/entity/warehouse/Warehouse.types';
import { IConsumables, IConsumablesListItem } from "@/entity/consumables/consumables.types";

@Component({
    components: { FormGroup, PageTitle },
    methods: { moment }
})
export default class VisitConsumablesForms extends Vue {
    @Prop() readonly service_id!: number;
    @Prop() form!:  VisitGeneralForm;


    addValueConsum() {
      this.form.consumables_data?.push({});
      this.$emit('input', this.form.consumables_data);
      console.log(this.form.consumables_data);
    } 

    updateValueConsum() {
        console.debug(JSON.stringify(this.form.consumables_data));
        this.$emit('input', this.form.consumables_data);
        console.log(this.form.service_data);

    }

    async deleteValueConsum(index : any, id:any) {
        console.clear();
        console.log(index);
  
        if (( await ConsumableStore.delete({id: id}))) {
            this.form.consumables_data?.splice(index, 1);
            console.debug(JSON.stringify(this.form.consumables_data));
            this.$emit('input', this.form.consumables_data);
            message.success(i18nText("Расходник успешно удален"));
            await ConsumableStore.fetchAll();
            
        } else  {
            message.error(i18nText("Что то пошло не так..."))
        }

    
    }



    get service(): IServices | null {
        return ServiceStore.service;
    }

    get products(): Products | null {
        return ProductsStore.products
    }
    
    get stores(): IWarehouse | null {
      return StoresStore.warehouse;
    }

    get consumables(): IConsumables | null{
        return ConsumableStore.consumables;
    }
            
    async created(): Promise<void> {

        await ServiceStore.fetchAll({filter: {salon_id: this.form.salon_id}});

         await StoresStore.fetchAll()
            if(this.stores){
                console.log(i18nText("СКЛАДЫ"));
                console.log(StoresStore.warehouse!.data.filter(e => e.type_id == 1));
            }

        await ProductsStore.fetchAll()
            if(this.products){
                console.log(i18nText("ПРОДКУТЫ"));
                console.log(this.products);
            }
            console.log('forma -> ' );
            console.log(this.form);
    }
}
